<template>
  <div>
    <v-sheet class="transparent-background-color">
      <v-card class="page-card">
        <v-card-title class="mx-3">
          {{
            $t(
              isNew
                ? "CRUD.newInfo"
                : savable
                ? "CRUD.editInfo"
                : "CRUD.viewInfo",
              [$t("DistributionUsers.title")]
            )
          }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                @click="
                  $emit('mode', null);
                  $emit('input', null);
                "
                >fa-times
              </v-icon>
            </template>
            <span>
              {{ $t("CRUD.backToList", [$t("DistributionUsers.title")]) }}
            </span>
          </v-tooltip>
        </v-card-title>
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
        <v-card-text>
          <ValidationObserver ref="observer">
            <v-container>
              <!-- 配送线路名称 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("DistributionUsers.Fields.distribution_name") +
                    $t("Global.colon")
                  }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('DistributionUsers.Fields.distribution_name')"
                    rules="required"
                  >
                    <v-text-field
                      single-line
                      v-model="distribution_users.name"
                      :hint="isNew ? '' : $t('DistributionUsers.codeHint')"
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'name')
                          .concat(errors)
                      "
                    >
                      <template v-slot:message="{ key, message }">
                        <div :class="key == 0 ? 'danger--text' : ''">
                          {{ message }}
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{ distribution_users.name }}
                </v-col>
              </v-row>
              <!-- 备注 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("DistributionUsers.Fields.distribution_note") +
                    $t("Global.colon")
                  }}
                  <Required :show="savable" />
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <v-textarea
                    outlined
                    v-model="distribution_users.memo"
                  ></v-textarea>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{ distribution_users.memo }}
                </v-col>
              </v-row>
              <!-- 状态 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("DistributionUsers.Fields.status") + $t("Global.colon")
                  }}
                  <Required :show="savable" />
                </v-col>
                <v-col cols="9" md="7">
                  <v-radio-group row :readonly="!savable" v-model="distribution_users.status">
                    <v-radio
                      :label="$t('DistributionUsers.status.on')"
                      :key="1"
                      :value="1"
                    />
                    <v-radio
                      :label="$t('DistributionUsers.status.off')"
                      :key="0"
                      :value="0"
                    />
                  </v-radio-group>
                </v-col>
              </v-row>
              <!-- 排序 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("DistributionUsers.Fields.rank") }}
                  {{ $t("Global.colon") }}
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <v-text-field
                    single-line
                    dense
                    v-model="distribution_users.rank"
                    type="number"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{ distribution_users.rank }}
                </v-col>
              </v-row>
            </v-container>
          </ValidationObserver>
        </v-card-text>
      </v-card>
      <v-card class="page-opts">
        <v-card-title>
          <v-row dense>
            <v-col cols="12">
              <!-- 返回 -->
              <v-btn
                outlined
                color="secondary"
                class="elevation-1"
                block
                @click="
                  $emit('input', null);
                  $emit('mode', null);
                "
              >
                <v-icon small class="pe-1">fa-times</v-icon>
                {{ $t("CRUD.backToList", [$t("DistributionUsers.title")]) }}
              </v-btn>
            </v-col>
            <v-col cols="12" v-if="isView">
              <!-- 编辑 -->
              <v-btn
                color="accent"
                block
                :disabled="loading && !distribution_users.id"
                @click="$emit('mode', 'edit')"
              >
                <v-icon small class="pe-1">fa-pencil-alt</v-icon>
                {{ $t("CRUD.editInfo", [$t("DistributionUsers.title")]) }}
              </v-btn>
            </v-col>
            <v-col cols="12" v-if="savable">
              <!-- 保存 -->
              <v-btn
                color="success"
                block
                :disabled="loading && !distribution_users.id"
                @click="save()"
              >
                <v-icon small class="pe-1">fa-save</v-icon>
                {{ $t("CRUD.saveInfo", [$t("DistributionUsers.title")]) }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
      </v-card>
    </v-sheet>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Consts from "@/consts.js";
import Required from "@/components/plugins/Required";
import DistributionUsers from "@/api/distribution_users";
// import SearcherStockDistrict from "@/components/plugins/SearcherStockDistrict";
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  name: "StockDetail",

  props: ["value", "mode"],

  components: {
    Required,
    // SearcherStockDistrict,
    ValidationObserver,
    ValidationProvider,
  },

  computed: {
    isView() {
      return !this.mode || this.mode == "view";
    },
    savable() {
      return this.mode == "edit" || this.mode == "new";
    },
    isNew() {
      return this.mode == "new";
    },
    status() {
      return Consts.stock.status;
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading"]),
  },

  data: () => ({
    serverErrors: [],
    distribution_users: {},
  }),

  methods: {
    //   保存线路管理 -----------------------------------
    save() {
      this.$store.dispatch("fullscreenLoading");
      this.serverErrors = []; //重置远端错误提示
      this.$refs.observer.validate().then(
        function (result) {
          if (result) {
            var distribution_users = JSON.parse(
              JSON.stringify(this.distribution_users)
            );
            //校验成功再提交
            DistributionUsers.save(distribution_users.id, distribution_users)
              .then(
                function (response) {
                  if (response.data.status.isOK()) {
                    this.$emit("save", this.distribution_users);
                    this.$emit("mode", null);
                    this.$emit("input", null);
                  } else if (
                    response.data.error &&
                    response.data.error.data &&
                    "ERR333" == response.data.error.code
                  ) {
                    this.serverErrors = response.data.error.data;
                  }
                  this.$store.dispatch("fullscreenLoadingStop");
                }.bind(this)
              )
              .catch(
                function () {
                  this.$store.dispatch("fullscreenLoadingStop");
                }.bind(this)
              );
          } else {
            this.$store.dispatch("fullscreenLoadingStop");
          }
        }.bind(this)
      );
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.serverErrors = []; //重置远端错误提示
        if (this.value && this.value.id) {
          this.distribution_users = JSON.parse(JSON.stringify(this.value));
        } else {
          // 新建线路，初始化默认值
          this.distribution_users = {
            distribution_center_id: this.$route.query.stock_id,
            name: "",
            memo: "",
            status: 1,
          };
        }
        this.$scrollTop(); //返回顶部
      },
    },
    mode: {
      immediate: true, //初始赋值也调用
      handler() {
        if (this.mode == "new") {
          // 新建线路，初始化默认值
          this.distribution_users = {
            distribution_center_id: this.$route.query.stock_id,
            name: "",
            memo: "",
            status: 1,
          };
        }
      },
    },
  },
};
</script>